import * as firebase from 'firebase'
// import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBAYrMMgrAheIiamXl1pGT38cd-8TITC8A',
  authDomain: 'new-norms.firebaseapp.com',
  databaseURL: 'https://new-norms.firebaseio.com',
  projectId: 'new-norms',
  storageBucket: 'new-norms.appspot.com',
  messagingSenderId: '644927726009',
  appId: '1:644927726009:web:f6b395613b0e8154329668',
  measurementId: 'G-XKSTLK47MM'
}

const app = firebase.initializeApp(firebaseConfig)

const firestore = app.firestore()

const storing = app.storage()

export default { firestore, storing, app }
